<template>
  <div id="app">
    <div class="figbLogo">
      <img src="http://www.federbridge.it/Mobile/Immagini/LogoFIGB.png" alt="Logo">
    </div>
    <sidebar></sidebar>
    <router-view></router-view>
  </div>
</template>

<script>
import Sidebar from './components/core/Sidebar';
import {mapActions, mapGetters} from 'vuex';
import {configureFetch} from '@/lib/fetcher';

export default {
  name: 'App',
  data() {
    return {
      connection: null,
      hub: null,
      payload: null,
    }
  },
  components: {Sidebar},
  beforeMount() {
    configureFetch()
        .setClientId('WFigb')
        .setGlobalUrlPrefix(this.isInDebug ? '/webApp' : '/WFigb/webApp');
    this.payload = JSON.parse(atob(new URLSearchParams(window.location.search).get('payload') ?? ''));
    this.changePayload(this.payload);
    this.changeContext(false);
    if (this.configurations.UseTimers || this.isInDebug)
    {
      this.$timer.start('checkUpdate');
      this.$timer.start('checkLooseUpdate');
    }
  },
  mounted() {
    var scripts = [
      "https://cdn.roboflow.com/0.2.26/roboflow.js"
    ];
    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      document.head.appendChild(tag);
    });
  },
  computed: {
    ...mapGetters(
        {
          useCollectorContest: 'webApp/useCollectorContest',
          configurations: 'webApp/configurations',
          currentToken: 'webApp/currentToken',
        }
    ),
    getEnv() {
      return process.env.NODE_ENV;
    },
    isInDebug() {
      return this.getEnv === 'development';
    }
  },
  methods: {
    ...mapActions({
      loadTournamentInfo: 'tournament/loadTournamentInfo',
      loadConfigurations: 'webApp/loadConfigurations',
      loadSectors: 'tournament/loadSectors',
      loadPlayerList: 'players/loadPlayerList',
      loadDeals: 'deals/loadDeals',
      loadRankList: 'ranks/loadRankList',
      loadMatches: 'matches/loadMatches',
      changePayload: 'webApp/changePayload',
      changeContext: 'webApp/changeContext'
    }),
    dispatchContestEvents(message) {
      let {Event, Payload} = message;
      Payload = JSON.parse(Payload) || '';

      switch (Event) {
        case 'update':
          this.updateContest(Payload);
          break;
        case 'reset':
          window.location.reload();
          break;
      }
    },
    updateContest(element) {
      if(this.configurations.UseTimers) return;

      switch (element) {
        case 'tournamentInfo':
          this.loadTournamentInfo();
          break;
        case 'configurations':
          this.loadConfigurations();
          break;
        case 'players':
          this.loadPlayerList();
          break;
        case 'ranks':
          this.loadRankList();
          break;
        case 'matches':
          this.loadMatches();
          break;
        case 'sectors':
        case 'deals':
        case 'played':
          this.loadSectors();
          this.loadDeals();
          break;
        case 'all':
          this.checkCompleteUpdate();
          break;
      }
    },
    checkUpdate() {
      this.loadDeals();
    },
    checkCompleteUpdate() {
      this.checkUpdate();
      this.checkLooseUpdate();
    },
    checkLooseUpdate() {
      this.loadTournamentInfo();
      this.loadConfigurations();
      this.loadPlayerList();
      this.loadRankList();
      this.loadMatches();
      this.loadSectors();
    },
    connectToSignalR(jwt) {
      this.$signalr.start({
        qs: {token: jwt}, // query string
        hubs: {
          contestHub: {
            receiveMessage: message => this.dispatchContestEvents(message)
          }
        },
        onConnected: () => this.checkCompleteUpdate(),
        onDisconnected: () => console.warn('Disconnesso'),
        onReconnecting: () => console.warn('Reconnect in corso...'),
        onReconnected: () => this.checkCompleteUpdate(),
        onError: err => console.error('Errore SignalR:', err)
      })
    }
  },
  watch: {
    useCollectorContest: {
      handler(newValue) {
        document.body.style.backgroundColor = newValue ? '#D8F9FF' : 'white';
      },
      immediate: true
    },
    currentToken: {
      handler(newValue) {
        this.connectToSignalR(newValue);
      }
    },
    configurations: {
      handler(newValue) {
        if (newValue.UseTimers || this.isInDebug) {
          if (newValue.RefreshRate != null) {
            if (newValue.RefreshRate !== this.timers.checkUpdate.time) {
              this.timers.checkUpdate.time = newValue.RefreshRate;
              this.$timer.stop('checkUpdate');
              this.$timer.start('checkUpdate');
            }
          }

          if (newValue.LooseRefreshRate != null) {
            if (newValue.LooseRefreshRate !== this.timers.checkLooseUpdate.time) {
              this.timers.checkLooseUpdate.time = newValue.LooseRefreshRate;
              this.$timer.stop('checkLooseUpdate');
              this.$timer.start('checkLooseUpdate');
            }
          }
        } else {
          this.$timer.stop('checkUpdate');
          this.$timer.stop('checkLooseUpdate');
        }
      }
    }
  },
  timers: {
    checkUpdate: {time: 5001, repeat: true, immediate: true},
    checkLooseUpdate: {time: 5001, repeat: true, immediate: true}
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top: 60px;
}

.figbLogo {
  z-index: -99;
  opacity: 0.08;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
